import { render, staticRenderFns } from "./hazardDetail.vue?vue&type=template&id=c619a5aa&scoped=true&"
import script from "./hazardDetail.vue?vue&type=script&lang=ts&"
export * from "./hazardDetail.vue?vue&type=script&lang=ts&"
import style0 from "./hazardDetail.vue?vue&type=style&index=0&id=c619a5aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c619a5aa",
  null
  
)

export default component.exports